module.exports = __webpack_public_path__ + "static/media/aggressive.cc1711b5.svg";